import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
//import { initializeApp } from '@firebase/app';
import { initializeApp } from 'firebase/app';
const firebaseConfig = {
  apiKey: 'AIzaSyAqmqY_v6p_VTTN9ZcOWcTLr3IQUY_x4QU',
  authDomain: 'react-hooks-blog-3da10.firebaseapp.com',
  projectId: 'react-hooks-blog-3da10',
  storageBucket: 'react-hooks-blog-3da10.appspot.com',
  messagingSenderId: '913865657809',
  appId: '1:913865657809:web:d13d26d780b4d4353be4f0',
};

// Initialize Firebase

firebase.initializeApp(firebaseConfig);
export const firestore = firebase.firestore();
